import { z } from 'zod';

/**
 * Close forgotten check-outs, many at once (owner, 2026-10-01: "option to force
 * check out"). Each item names the check-in the screen SAW (`checkedInAt`), so a
 * worker who checked out, or checked in again, after the list was loaded is
 * reported back as changed instead of being closed against a stale picture.
 */
export const ForceCheckoutSchema = z.object({
  items: z
    .array(
      z.object({
        employeeId: z.string().min(1),
        checkedInAt: z.string().datetime(),
        at: z.string().datetime(),
      })
    )
    .min(1)
    .max(200),
  reason: z.string().trim().max(500).optional().nullable(),
});
export type ForceCheckout = z.infer<typeof ForceCheckoutSchema>;

/**
 * What happened to one item. `changed`: the open check-in is not the one sent.
 * `saved_still_open`: the check-out was written, but the recomputed day is
 * still unclosed (still a missing check-out) — never reported as `closed`.
 */
export const ForceCheckoutOutcomeSchema = z.object({
  employeeId: z.string(),
  outcome: z.enum(['closed', 'saved_still_open', 'changed', 'refused']),
  /**
   * Why it was refused — the missed check-out's own time rule
   * (`missedCheckoutTimeSkip`), so the two fixes for one forgotten check-out
   * cannot disagree: BEFORE_CHECK_IN | TOO_LONG | IN_FUTURE | TOO_SHORT.
   */
  reason: z.enum(['BEFORE_CHECK_IN', 'IN_FUTURE', 'TOO_LONG', 'TOO_SHORT']).nullable(),
  eventId: z.string().nullable(),
});
export type ForceCheckoutOutcome = z.infer<typeof ForceCheckoutOutcomeSchema>;
